import AbstractComponent from "./abstract-component";

const createTemplate = (title, message, style) => {
  return (
    `<section class="modal">
      <div class="modal__overlay"></div>
      <div class="modal__wrap">
        <button class="modal__closeButton" type="button">Закрыть</button>
    ${title
      ? `<h2 class="modal__title ${style === `error` ? `modal__title--red` : ``}">${title}</h2>`
      : ``
    }
        <p class="modal__text">${message}</p>

        ${style === `error`
      ? `<div class="modal__buttonWrap" data-mode="button" style="margin-bottom: 0;">
          <button class="modal__button" type="button">Ok</button>
        </div>`
      : ``}
      </div>
    </section>`
  );
};


export default class RespectModalComponent extends AbstractComponent {
  constructor({title = ``, message = `Спасибо за Ваше обращение!`, style = `respect`}) {
    super();

    this._title = title;
    this._message = message;
    this._style = style;
  }

  getTemplate() {
    return createTemplate(this._title, this._message, this._style);
  }

  setShowClass() {
    this.getElement().classList.add(`modal--show`);
  }

  setHideClass() {
    this.getElement().classList.add(`modal--hide`);
  }

  setButtonClickHandler(handler) {
    this.getElement().querySelector(`.modal__button`)
    .addEventListener(`click`, handler);
  }

  setCloseButtonClickHandler(handler) {
    this.getElement().querySelector(`.modal__closeButton`)
    .addEventListener(`click`, handler);
  }

  setOverlayClickHandler(handler) {
    this.getElement().querySelector(`.modal__overlay`)
    .addEventListener(`click`, handler);
  }
}
